import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getComplaints(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createComplaint(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/complaints" + pathname, body);
}

export async function updateComplaint(
  pathname,
  queryParams,
  body) {
  return await instance({
    baseURL: baseURL,
  }).post("/complaints" + pathname + queryParams, body);
}

export async function deleteComplaint(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/complaints" + pathname + queryParams);
}
